import React from 'react';
import { Skeleton } from '../Skeleton/Skeleton';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { IAsyncDataHandler } from './AsyncDataHandler.types';
import classNames from 'classnames';

const DefaultWidth = '100%';
const DefaultHeight = '32px';

export const AsyncDataHandler: React.FC<IAsyncDataHandler> = ({
  isLoading,
  error,
  loader = { width: DefaultWidth, height: DefaultHeight },
  errorComponent = (err) => <ErrorMessage error={err} />,
  children,
  className = '',
}) => {
  if (isLoading)
    return (
      <Skeleton
        width={loader.width || DefaultWidth}
        height={loader.height || DefaultHeight}
        className={classNames('flex items-center justify-center', className)}
      />
    );
  if (error) return <>{errorComponent(error)}</>;

  return <>{children}</>;
};
